export const ADULTS_DEFAULT_AGE = 30;

export const CHILDREN_MIN_AGE = 2;
export const CHILDREN_MAX_AGE = 17;
export const CHILDREN_DEFAULT_AGE = 10;

export const BABIES_MIN_AGE = 0;
export const BABIES_MAX_AGE = 2;
export const BABIES_DEFAULT_AGE = 1;
